import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Error } from '../Error';
import { Input } from '../Input';
import { Label } from '../Label';
import { FilterActions } from './FilterActions';
import styles from './styles.scss';
export var FilterNumber = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterNumber, _React$Component);

  var _super = _createSuper(FilterNumber);

  function FilterNumber(props) {
    var _this;

    _classCallCheck(this, FilterNumber);

    _this = _super.call(this, props);

    _this.handleApplyFilter = function () {
      return _this.props.onApplyFilter({
        minValue: _this.state.minValue,
        maxValue: _this.state.maxValue
      });
    };

    _this.handleClearFilter = function () {
      return _this.props.onClearFilter();
    };

    _this.handleMinChange = function (value) {
      return value === '' ? _this.setState({
        minValue: ''
      }) : _this.setState({
        minValue: Number(value)
      });
    };

    _this.handleMaxChange = function (value) {
      return value === '' ? _this.setState({
        maxValue: ''
      }) : _this.setState({
        maxValue: Number(value)
      });
    };

    _this.state = props.filterState;
    return _this;
  }

  _createClass(FilterNumber, [{
    key: "render",
    value: function render() {
      var maxValidIsNumber = typeof this.state.maxValue === 'number';
      var hasEndValueError = maxValidIsNumber && +this.state.maxValue >= 0 && this.state.maxValue < this.state.minValue;
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: styles.formItem
      }, React.createElement(Label, null, "Greater than or equal to"), React.createElement(Input.Number.Small, {
        dataTest: "start-value-numeric-input",
        placeholder: "Lowest number",
        value: this.state.minValue,
        onChange: this.handleMinChange,
        disabled: this.props.filtersDisabled
      })), React.createElement("div", {
        className: styles.formItem
      }, React.createElement(Label, null, "Less than or equal to"), React.createElement(Input.Number.Small, {
        dataTest: "end-value-numeric-input",
        placeholder: "Highest number",
        value: this.state.maxValue,
        onChange: this.handleMaxChange,
        disabled: this.props.filtersDisabled
      })), hasEndValueError && React.createElement(Error, {
        dataTest: "end-value-error-message"
      }, "This value needs to be higher than the first one"), React.createElement(FilterActions, {
        disableApplyButton: hasEndValueError || this.props.filtersDisabled,
        onClearFilter: this.handleClearFilter,
        onApplyFilter: this.handleApplyFilter
      }));
    }
  }]);

  return FilterNumber;
}(React.Component);